import Container from './RecordsViewer.container';

export default Container;
